var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMountains = function SvgIconMountains(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.5 4.875a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0M15.375 2a2.875 2.875 0 1 0 0 5.75 2.875 2.875 0 0 0 0-5.75m-6.75 3.735a1.76 1.76 0 0 0-1.499.838l-.01.017L.263 18.243a1 1 0 0 0 .862 1.507h21.309a1 1 0 0 0 .86-1.51l-4.912-8.287-.008-.014a1.76 1.76 0 0 0-2.998 0l-.009.015-1.632 2.76-3.601-6.124-.01-.017a1.76 1.76 0 0 0-1.499-.838m6.27 8.95 1.802 3.065h3.982l-3.804-6.417zm-.518 3.065L11.583 13H5.667l-2.794 4.75zM8.625 7.97 10.407 11H6.843z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMountains;